module.exports = __webpack_public_path__ + "static/media/single.a633606b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/single.png
// module id = 1244
// module chunks = 0